import cn from "classnames";

import { CheckIcon } from "@/components/icons/check.icon";
import { CheckmarkThinIcon } from "@/components/icons/checkmarkThin.icon";
import { CloseIcon } from "@/components/icons/close.icon";

export type StatusIconVariant = "check" | "close" | "thinCheck";

/** ADT = navy circle / white check. Competitor = light-blue circle / navy check. */
export type StatusIconCheckTone = "adt" | "competitor";

export const StatusIcon = ({
  variant,
  srOnlyLabel,
  className,
  checkTone = "adt",
}: StatusIconProps) => {
  if (variant === "thinCheck") {
    return (
      <span
        className={cn(
          "text-greyscale-headline inline-flex shrink-0 items-start",
          className,
        )}>
        <CheckmarkThinIcon className="block h-6 w-6 shrink-0" />
        <span className="sr-only">{srOnlyLabel}</span>
      </span>
    );
  }

  if (variant === "check") {
    const isCompetitor = checkTone === "competitor";
    return (
      <span
        data-testid={
          isCompetitor
            ? "status-icon-check-competitor"
            : "status-icon-check-adt"
        }
        className={cn(
          "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full",
          isCompetitor ? "bg-primary-100" : "bg-secondary",
          className,
        )}>
        <CheckIcon
          className={cn(
            "h-6 w-6",
            isCompetitor ? "text-secondary" : "text-white",
          )}
        />
        <span className="sr-only">{srOnlyLabel}</span>
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-red-700",
        className,
      )}>
      <CloseIcon className="h-6 w-6 text-white" />
      <span className="sr-only">{srOnlyLabel}</span>
    </span>
  );
};

type StatusIconProps = {
  variant: StatusIconVariant;
  srOnlyLabel: string;
  className?: string;
  /** Only applied when variant is `check`. Defaults to ADT styling. */
  checkTone?: StatusIconCheckTone;
};
